export const localStorageService = {
    getVippsMobileNo,
    setVippsMobileNo,
    clearStorage,
    clearAllStorage, // Full cleanup including phone number (use sparingly)
}

// Helper function to handle storage errors, especially QuotaExceededError
function handleStorageError(error, key, operation) {
    if (error && error.name === 'QuotaExceededError') {
        console.warn('Storage quota exceeded for', key, 'during', operation);
        // Try to free up space by removing old entries
        try {
            // Remove only our specific key to free up space
            localStorage.removeItem('vippsMobileNo');
            console.info('Cleared vippsMobileNo to free up storage quota');
        } catch (cleanupError) {
            console.warn('Failed to cleanup storage after quota error:', cleanupError);
        }
    } else if (error && error.name === 'SecurityError') {
        console.warn('Security error accessing localStorage for', key, 'during', operation);
    } else if (error) {
        console.warn('Storage error for', key, 'during', operation, ':', error);
    }
}

// Clear storage but preserve phone number (vippsMobileNo)
// This is the default cleanup method - phone number should persist
function clearStorage() {
    try {
        // Save phone number before clearing
        var phoneNumber = localStorage.getItem('vippsMobileNo');
        
        // Clear all localStorage
        localStorage.clear();
        
        // Restore phone number if it existed
        if (phoneNumber) {
            localStorage.setItem('vippsMobileNo', phoneNumber);
        }
    } catch (error) {
        handleStorageError(error, 'all', 'clearStorage');
    }
}

// Clear ALL storage including phone number
// Use this only when explicitly needed (e.g., user logout, account deletion)
function clearAllStorage() {
    try {
        localStorage.removeItem('vippsMobileNo');
        localStorage.clear();
    } catch (error) {
        handleStorageError(error, 'all', 'clearAllStorage');
    }
}

function getVippsMobileNo() {
    try {
        return localStorage.getItem('vippsMobileNo');
    } catch (error) {
        handleStorageError(error, 'vippsMobileNo', 'getVippsMobileNo');
        return null;
    }
}

function setVippsMobileNo(mobileNo) {
    try {
        localStorage.setItem('vippsMobileNo', mobileNo);
        return true;
    } catch (error) {
        handleStorageError(error, 'vippsMobileNo', 'setVippsMobileNo');
        
        // If QuotaExceededError, try cleanup and retry once
        if (error && error.name === 'QuotaExceededError') {
            try {
                // Clear old data and retry
                localStorage.removeItem('vippsMobileNo');
                localStorage.setItem('vippsMobileNo', mobileNo);
                console.info('Successfully stored vippsMobileNo after cleanup');
                return true;
            } catch (retryError) {
                console.warn('Failed to store vippsMobileNo even after cleanup:', retryError);
                return false;
            }
        }
        
        return false;
    }
}